export default {
    invalid_title: "Cupom {0} é inválido",
    utilizing_title: "Utilizando cupom {0}",
    error_expired: "Cupom expirou",
    error_not_yet_valid: "Cupom será válido a partir de",
    error_used: "Cupom já utilizado",
    error_not_found: "Código não encontrado",
    benefit_prefix: "Conceder o benefício de",
    irreversible: "Essa ação é irreversível.",
    purchase_value_label: "Qual o valor da compra que o cliente está fazendo?",
    order_value_placeholder: "Valor do pedido",
    min_value_error: "O valor precisa ser superior à R${0}",
    discount_label: "Desconto: R${0}",
    close_button: "Fechar",
    confirm_button: "Confirmar o uso",
    used_title: "Cupom {0} foi utilizado",
    used_success: "Cupom de {0} foi utilizado com sucesso.",
    used_invalid_now: "O cupom {0} não é mais válido",
    generic_error: "Algo deu errado, tente novamente mais tarde",
    incentive_text_label: "Texto do incentivo",
    probability_label: "Probabilidade",
    name_locked_tooltip:
        "Esse cupom possui códigos já gerados e não pode ser removido ou ter seu nome alterado.",
    generated_singular: "gerado",
    generated_plural: "gerados",
    conjunction_and: "e",
    used_singular: "resgatado",
    used_plural: "resgatados",
    delete_coupon: "Deletar cupom",
    remove_notice: "Cupom {0} será removido ao salvar.",
    undo: "Desfazer",
    empty_prefix: "Você ainda não possui nenhum cupom,",
    empty_cta: "crie o primeiro agora!",
    new_coupon: "Novo Cupom",
    registered_coupons: "Cupons cadastrados",
    total_probability_error:
        "A soma das probabilidades deve ser igual a 100 mas está {0}",
    saved_success: "Salvo com sucesso",
    save_button: "Salvar",
    page_title: "Kevi | Cupons",
};
